import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Dialog, DialogTitle, DialogBody, DialogActions } from './catalyst/dialog';
import { Button } from './catalyst/button';

const STEPS = [
  {
    title: 'Set up your profile',
    body: 'Add your name and photo so teammates can recognize you in Work and Chat.',
    actionLabel: 'Open profile',
    path: '/profile'
  },
  {
    title: 'Invite your team',
    body: 'Onahiri is useful from day one when two or three people can assign work and talk in the same place.',
    actionLabel: 'Invite people',
    path: '/settings/users'
  },
  {
    title: 'Create your first task',
    body: 'Start in OWork. A single task with an owner and due date is enough to see the board, calendar, and chat thread.',
    actionLabel: 'Go to OWork',
    path: '/work'
  },
  {
    title: 'Start a conversation',
    body: 'Open OTalk for day-to-day messages, or OPulse to share an update with the whole team.',
    actionLabel: 'Open OTalk',
    path: '/chat'
  }
];

function FirstRunWizard({ open, onClose }) {
  const navigate = useNavigate();
  const [stepIndex, setStepIndex] = useState(0);
  const step = STEPS[stepIndex];
  const isLast = stepIndex === STEPS.length - 1;

  const go = (path) => {
    onClose();
    navigate(path);
  };

  return (
    <Dialog open={open} onClose={onClose} size="lg">
      <DialogTitle>Welcome to Onahiri</DialogTitle>
      <DialogBody>
        <p className="text-sm text-zinc-500">
          Step {stepIndex + 1} of {STEPS.length}
        </p>
        <div className="mt-3 mb-4 flex gap-1">
          {STEPS.map((item, index) => (
            <span
              key={item.title}
              className={`h-1.5 flex-1 rounded-full ${index <= stepIndex ? 'bg-zinc-900' : 'bg-zinc-200'}`}
            />
          ))}
        </div>
        <h3 className="text-base font-semibold text-zinc-900">{step.title}</h3>
        <p className="mt-2 text-sm leading-6 text-zinc-600">{step.body}</p>
      </DialogBody>
      <DialogActions>
        <Button plain onClick={onClose}>
          Skip for now
        </Button>
        {!isLast ? (
          <Button outline onClick={() => setStepIndex((current) => current + 1)}>
            Next
          </Button>
        ) : null}
        <Button color="dark" onClick={() => go(step.path)}>
          {step.actionLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default FirstRunWizard;
